import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextWrap"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 17.25H9V18.75H3V17.25ZM18.3923 10.5H3V12H18.375C19.8247 12 21 13.1753 21 14.625C21 16.0747 19.8247 17.25 18.375 17.25H14.121L16.0605 15.3105L15 14.25L11.25 18L15 21.75L16.0605 20.6895L14.121 18.75H18.3998C20.6779 18.7479 22.5231 16.8994 22.521 14.6213C22.5189 12.3431 20.6704 10.4979 18.3923 10.5ZM3 3.75H21V5.25H3V3.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextWrap.vue"]]);
